var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSunIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    verticalAlign: "middle"
  }
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.03125 0.25C8.44546 0.25 8.78125 0.585786 8.78125 1V1.9375C8.78125 2.35171 8.44546 2.6875 8.03125 2.6875C7.61704 2.6875 7.28125 2.35171 7.28125 1.9375V1C7.28125 0.585786 7.61704 0.25 8.03125 0.25Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.5335 2.52906C13.8263 2.82195 13.8263 3.29682 13.5335 3.58972L12.8703 4.25284C12.5774 4.54574 12.1026 4.54574 11.8097 4.25284C11.5168 3.95995 11.5168 3.48507 11.8097 3.19218L12.4728 2.52906C12.7657 2.23616 13.2406 2.23616 13.5335 2.52906Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.375 8.03125C13.375 7.61704 13.7108 7.28125 14.125 7.28125H15.0625C15.4767 7.28125 15.8125 7.61704 15.8125 8.03125C15.8125 8.44546 15.4767 8.78125 15.0625 8.78125H14.125C13.7108 8.78125 13.375 8.44546 13.375 8.03125Z",
  fill: "currentColor"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.8097 11.8097C12.1026 11.5168 12.5774 11.5168 12.8703 11.8097L13.5335 12.4728C13.8263 12.7657 13.8263 13.2406 13.5335 13.5335C13.2406 13.8264 12.7657 13.8264 12.4728 13.5335L11.8097 12.8704C11.5168 12.5775 11.5168 12.1026 11.8097 11.8097Z",
  fill: "currentColor"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.03125 13.375C8.44546 13.375 8.78125 13.7108 8.78125 14.125V15.0625C8.78125 15.4767 8.44546 15.8125 8.03125 15.8125C7.61704 15.8125 7.28125 15.4767 7.28125 15.0625V14.125C7.28125 13.7108 7.61704 13.375 8.03125 13.375Z",
  fill: "currentColor"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.25284 11.8097C4.54574 12.1026 4.54574 12.5775 4.25284 12.8704L3.58972 13.5335C3.29682 13.8264 2.82195 13.8264 2.52906 13.5335C2.23616 13.2406 2.23616 12.7657 2.52906 12.4728L3.19218 11.8097C3.48507 11.5168 3.95995 11.5168 4.25284 11.8097Z",
  fill: "currentColor"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.25 8.03125C0.25 7.61704 0.585786 7.28125 1 7.28125H1.9375C2.35171 7.28125 2.6875 7.61704 2.6875 8.03125C2.6875 8.44546 2.35171 8.78125 1.9375 8.78125H1C0.585786 8.78125 0.25 8.44546 0.25 8.03125Z",
  fill: "currentColor"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.52906 2.52906C2.82195 2.23616 3.29682 2.23616 3.58972 2.52906L4.25284 3.19218C4.54574 3.48508 4.54574 3.95995 4.25284 4.25284C3.95995 4.54574 3.48508 4.54574 3.19218 4.25284L2.52906 3.58972C2.23616 3.29682 2.23616 2.82195 2.52906 2.52906Z",
  fill: "currentColor"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 5.25C6.48122 5.25 5.25 6.48122 5.25 8C5.25 9.51878 6.48122 10.75 8 10.75C9.51878 10.75 10.75 9.51878 10.75 8C10.75 6.48122 9.51878 5.25 8 5.25ZM3.75 8C3.75 5.65279 5.65279 3.75 8 3.75C10.3472 3.75 12.25 5.65279 12.25 8C12.25 10.3472 10.3472 12.25 8 12.25C5.65279 12.25 3.75 10.3472 3.75 8Z",
  fill: "currentColor"
})));
export default SvgSunIcon;